import { Link } from "@tanstack/react-router";
import { Bell } from "lucide-react";
import { type FC } from "react";

import { m } from "@recobra/i18n/messages";
import { Badge } from "@recobra/ui/badge";
import { Button } from "@recobra/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@recobra/ui/popover";

import { NotificationInbox } from "./NotificationInbox";
import { useNotificationSummary } from "./useNotificationSummary";

export const NotificationBell: FC = () => {
  const { data: summary } = useNotificationSummary();
  const unread = summary?.unread ?? 0;

  return (
    <Popover>
      <PopoverTrigger
        render={
          <Button
            variant="ghost"
            size="icon"
            className="relative"
            aria-label={m.notifications_bell_label()}
          />
        }
      >
        <Bell />
        {unread > 0 ? (
          <Badge className="pointer-events-none absolute -top-1 -right-1 flex min-w-5 border-2 border-background bg-info px-1 text-[10px] leading-none text-info-foreground tabular-nums">
            {unread > 9 ? "9+" : unread}
          </Badge>
        ) : null}
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[min(30rem,calc(100vw-2rem))] overflow-hidden p-0">
        <NotificationInbox previewLimit={5} showFooter={false} showViewAll />
        <div className="sr-only">
          <Link to="/notifications">{m.notifications_view_all()}</Link>
        </div>
      </PopoverContent>
    </Popover>
  );
};
